import { Alert, Modal } from 'antd';

interface Props {
  open: boolean;
  recipientCount: number;
  /** Label of the audience the selection was made against, e.g. “In service”. */
  audience: string;
  confirmLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const SyncConfirmModal = ({
  open,
  recipientCount,
  audience,
  confirmLoading,
  onConfirm,
  onCancel,
}: Props) => (
  <Modal
    open={open}
    title={`Sync ${recipientCount} recipient${recipientCount === 1 ? '' : 's'} to Listmonk?`}
    okText="Run full-rewrite sync"
    cancelText="Cancel"
    confirmLoading={confirmLoading}
    onOk={onConfirm}
    onCancel={onCancel}
    destroyOnClose
  >
    <p>
      This is a <strong>full rewrite</strong> of the “Product updates” list, from the{' '}
      <strong>{audience}</strong> audience. Anyone not in your current selection is removed from the
      list.
    </p>
    <Alert
      type="warning"
      showIcon
      message="The previous selection is discarded. Removal only drops people from this list — it never deletes their subscriber record or consent state."
    />
  </Modal>
);

export default SyncConfirmModal;
